import { INTERCOM_DATA_STALE_TIME_MS, IntercomDataDto } from '@shared/core/users'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_INTERCOM_DATA_CACHE_KEY = 'intercom-data'

export function useIntercomData(options?: UseQueryOptions<IntercomDataDto | null>) {
  const handleRetry = useHandleRetry()

  return useQuery([GET_INTERCOM_DATA_CACHE_KEY], () => ApiService.Profile.getIntercomData(), {
    staleTime: INTERCOM_DATA_STALE_TIME_MS,
    refetchOnWindowFocus: true,
    retry: handleRetry,
    ...options,
  })
}
